import { createFileRoute } from '@tanstack/react-router';
import UserLayout from '@components/layout/UserLayout.tsx';
import ClientDashboard from '@features/client/dashboard/ClientDashboard.tsx';

/**
 * Úvodní obrazovka klienta = přehled.
 *
 * Dřív tu byl katalog, ale ten má vlastní routu `/catalog` s identickou definicí
 * (a spodní menu na ni odkazuje samostatnou záložkou), takže se přepnutím nic
 * neztratilo – jen se přestala duplikovat stejná stránka na dvou cestách.
 */
export const Route = createFileRoute('/c/$orgId/$portalId/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <UserLayout>
      <ClientDashboard />
    </UserLayout>
  );
}
